<template>
  <Breadcrumbs title="" main="Home" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          
          <!-- <h3 style="padding-left: 4%;padding-top: 3%;">RUNRACE.IN.TH</h3> -->
          <b style="padding-left: 4%;padding-top: 2%;">&nbsp;</b>
          <p style="padding-left: 4%;padding-right: 5%;">&nbsp;&nbsp; {{this.currentLanguage ==='en'?'Running Event Registration System Our platform offers a complete set of features, all in one place. Easy to set up — get your event up and running in just one day. We provide both free registration options and standard paid registration services.':'ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว ติดต่อเปิดงานง่าย ใช้เวลาเพียง 1 วัน.. เรามีให้บริการทั้งในรูปแบบของการรับสมัครฟรี และการรับสมัครแบบทั่วๆไป...'}}</p>
          <div class="d-flex justify-content-center">
              <img style="align-items: center; width: 95%;border-radius: 0.6em;;" src="../../assets/images/running/runrace-cover.jpg" />
            </div>

            <h3 style="padding-left: 2rem;padding-top: 3%;padding-bottom: 0.13rem;">| {{this.currentLanguage ==='en'?'All Events':'กิจกรรมล่าสุด'}}</h3>
          <!-- <div style="padding-top: 0%;" class="my-gallery card-body row gallery-with-description" itemscope=""> -->
            <div v-if="loading" style="padding-top: 0%;" class="my-gallery card-body row gallery-with-description" itemscope="">
              <figure class="col-xl-4 col-sm-6" v-for="index in skeletonCount" :key="'open-skeleton-' + index">
                <div class="skeleton-card">
                  <div class="skeleton skeleton-image"></div>
                  <div class="caption skeleton-caption">
                    <div class="skeleton skeleton-title"></div>
                    <div class="skeleton skeleton-line"></div>
                    <div class="skeleton skeleton-line skeleton-line-short"></div>
                  </div>
                </div>
              </figure>
            </div>
            <div style="padding-top: 0%;" class="my-gallery card-body row gallery-with-description" itemscope="" v-else>
              <figure class="col-xl-4 col-sm-6" v-for="(src, index) in this.events_open" :key="index">
                <a v-bind:href="src.event_key" class="event-card">
                  <img :src="src.coverurl" class="event-cover" style="border-top-left-radius: 0.6em;border-top-right-radius: 0.6em;border: 0px;filter: drop-shadow(0 -1mm 4mm rgb(0, 0, 0,20%));" alt="Image description" />
                  <span class="event-status-badge" :class="isEventOpen(src) ? 'event-status-open' : 'event-status-closed'">
                    <span v-if="isEventOpen(src)" class="event-live-dot"></span>
                    {{ isEventOpen(src) ? (this.currentLanguage === 'en' ? 'Open' : 'เปิดรับสมัคร') : (this.currentLanguage === 'en' ? 'Closed' : 'ปิดรับสมัครแล้ว') }}
                  </span>
                  <div class="caption" style="box-shadow: 0 0em 1em rgb(0 0 0 / 50%);border-bottom-left-radius: 0.6em;border-bottom-right-radius: 0.6em;border: 0px;">
                    <h4>{{ src.title }}</h4>
                    <b><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ src.event_date_text }}</b>
                    <p><i class="fa fa-map-marker" aria-hidden="true"></i> &nbsp;{{ src.location }}</p>
                  </div>
                </a>
              </figure>
            </div>
          <!-- </div> -->
        </div>
      </div>
    </div>

    <div class="row" v-if="loading || this.events_soon.length > 0">
      <div class="col-sm-12">
        <div class="card-header">
          <h3> | {{this.currentLanguage ==='en'?'Event soon':'กิจกรรมที่กำลังจะเปิดรับสมัคร'}}</h3>
        </div>
        <div class="card">

          <div v-if="loading" class="my-gallery card-body row gallery-with-description" itemscope="">
            <figure class="col-xl-4 col-sm-6" v-for="index in skeletonCount" :key="'soon-skeleton-' + index">
              <div class="skeleton-card">
                <div class="skeleton skeleton-image"></div>
                <div class="caption skeleton-caption">
                  <div class="skeleton skeleton-title"></div>
                  <div class="skeleton skeleton-line"></div>
                  <div class="skeleton skeleton-line skeleton-line-short"></div>
                </div>
              </div>
            </figure>
          </div>
          <div v-else class="my-gallery card-body row gallery-with-description" itemscope="">
            <figure class="col-xl-4 col-sm-6" v-for="(src, index) in this.events_soon" :key="index">
              <a v-bind:href="src.event_key" class="event-card">
                <img :src="src.coverurl" class="event-cover" style="border-top-left-radius: 0.6em;border-top-right-radius: 0.6em;border: 0px;filter: drop-shadow(0 -1mm 4mm rgb(0, 0, 0,20%));" alt="Image description" />
                <span class="event-status-badge event-status-upcoming">
                  {{ this.currentLanguage === 'en' ? 'Not open yet' : 'ยังไม่เปิดรับสมัคร' }}
                </span>
                <div class="caption" style="box-shadow: 0 0em 1em rgb(0 0 0 / 20%);border-bottom-left-radius: 0.6em;border-bottom-right-radius: 0.6em;border: 0px;">
                  <h4>{{ src.title }}</h4>
                  <b><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ src.event_date_text }}</b>
                  <p><i class="fa fa-map-marker" aria-hidden="true"></i> {{ src.location }}</p>
                </div>
              </a>
            </figure>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
export default {
  setup() {
    const siteData = reactive({
      title: `ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว | RUNRACE.IN.TH`,
      description: `ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว ติดต่อเปิดงานง่าย ใช้เวลาเพียง 1 วัน.. | RUNRACE.IN.TH`,
      keywords: `หารูปวิ่ง,งานวิ่ง,RUNRACE,ระบบรับสมัครงานวิ่ง,รับสมัครงานวิ่ง, งานวิ่ง,runrace,สนามวิ่ง,วิ่งใหนดี,ระบบรับสมัครงานวิ่ง เชียงใหม่, ระบบรับสมัครงานวิ่ง นครราชสีมา, ระบบรับสมัครงานวิ่ง กาญจนบุรี, ระบบรับสมัครงานวิ่ง ตาก, ระบบรับสมัครงานวิ่ง อุบลราชธานี, ระบบรับสมัครงานวิ่ง สุราษฎร์ธานี, ระบบรับสมัครงานวิ่ง ชัยภูมิ, ระบบรับสมัครงานวิ่ง แม่ฮ่องสอน, ระบบรับสมัครงานวิ่ง เพชรบูรณ์, ระบบรับสมัครงานวิ่ง ลำปาง, ระบบรับสมัครงานวิ่ง อุดรธานี, ระบบรับสมัครงานวิ่ง เชียงราย, ระบบรับสมัครงานวิ่ง น่าน, ระบบรับสมัครงานวิ่ง เลย, ระบบรับสมัครงานวิ่ง ขอนแก่น, ระบบรับสมัครงานวิ่ง พิษณุโลก, ระบบรับสมัครงานวิ่ง บุรีรัมย์, ระบบรับสมัครงานวิ่ง นครศรีธรรมราช, ระบบรับสมัครงานวิ่ง สกลนคร, ระบบรับสมัครงานวิ่ง นครสวรรค์, ระบบรับสมัครงานวิ่ง ศรีสะเกษ, ระบบรับสมัครงานวิ่ง กำแพงเพชร, ระบบรับสมัครงานวิ่ง ร้อยเอ็ด, ระบบรับสมัครงานวิ่ง สุรินทร์, ระบบรับสมัครงานวิ่ง อุตรดิตถ์, ระบบรับสมัครงานวิ่ง สงขลา, ระบบรับสมัครงานวิ่ง สระแก้ว, ระบบรับสมัครงานวิ่ง กาฬสินธุ์, ระบบรับสมัครงานวิ่ง อุทัยธานี, ระบบรับสมัครงานวิ่ง สุโขทัย, ระบบรับสมัครงานวิ่ง แพร่, ระบบรับสมัครงานวิ่ง ประจวบคีรีขันธ์, ระบบรับสมัครงานวิ่ง จันทบุรี, ระบบรับสมัครงานวิ่ง พะเยา, ระบบรับสมัครงานวิ่ง เพชรบุรี, ระบบรับสมัครงานวิ่ง ลพบุรี, ระบบรับสมัครงานวิ่ง ชุมพร, ระบบรับสมัครงานวิ่ง นครพนม, ระบบรับสมัครงานวิ่ง สุพรรณบุรี, ระบบรับสมัครงานวิ่ง มหาสารคาม, ระบบรับสมัครงานวิ่ง ฉะเชิงเทรา, ระบบรับสมัครงานวิ่ง ราชบุรี, ระบบรับสมัครงานวิ่ง ตรัง, ระบบรับสมัครงานวิ่ง ปราจีนบุรี, ระบบรับสมัครงานวิ่ง กระบี่, ระบบรับสมัครงานวิ่ง พิจิตร, ระบบรับสมัครงานวิ่ง ยะลา, ระบบรับสมัครงานวิ่ง ลำพูน, ระบบรับสมัครงานวิ่ง นราธิวาส, ระบบรับสมัครงานวิ่ง ชลบุรี, ระบบรับสมัครงานวิ่ง มุกดาหาร, ระบบรับสมัครงานวิ่ง บึงกาฬ, ระบบรับสมัครงานวิ่ง พังงา, ระบบรับสมัครงานวิ่ง ยโสธร, ระบบรับสมัครงานวิ่ง หนองบัวลำภู, ระบบรับสมัครงานวิ่ง สระบุรี, ระบบรับสมัครงานวิ่ง ระยอง, ระบบรับสมัครงานวิ่ง พัทลุง, ระบบรับสมัครงานวิ่ง ระนอง, ระบบรับสมัครงานวิ่ง อำนาจเจริญ, ระบบรับสมัครงานวิ่ง หนองคาย, ระบบรับสมัครงานวิ่ง ตราด, ระบบรับสมัครงานวิ่ง พระนครศรีอยุธยา, ระบบรับสมัครงานวิ่ง สตูล, ระบบรับสมัครงานวิ่ง ชัยนาท, ระบบรับสมัครงานวิ่ง นครปฐม, ระบบรับสมัครงานวิ่ง นครนายก, ระบบรับสมัครงานวิ่ง ปัตตานี, ระบบรับสมัครงานวิ่ง กรุงเทพมหานคร, ระบบรับสมัครงานวิ่ง ปทุมธานี, ระบบรับสมัครงานวิ่ง สมุทรปราการ, ระบบรับสมัครงานวิ่ง อ่างทอง, ระบบรับสมัครงานวิ่ง สมุทรสาคร, ระบบรับสมัครงานวิ่ง สิงห์บุรี, ระบบรับสมัครงานวิ่ง นนทบุรี, ระบบรับสมัครงานวิ่ง ภูเก็ต, ระบบรับสมัครงานวิ่ง สมุทรสงคราม`,
      image: process.env.VUE_APP_IMAGE_COVER,
    })

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },
        {
          property: `og:title`,
          content: computed(() => siteData.title),
        },
        {
          property: `og:description`,
          content: computed(() => siteData.description),
        },
      ],

    })

  },
  data() {
    return {
      events_open: [],
      events_soon: [],
      events_end: [],
      skeletonCount: 6,
      loading: true,
      currentLanguage: 'th'
    };
  },
  
  
  async mounted(){
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
    this.loading = true
    let arr_event = await this.getEvents();

    for (let index = 0; index < arr_event.length; index++) {
      if (arr_event[index].event_status === 'OPEN') {
        this.events_open.push(arr_event[index])
      } else if (arr_event[index].event_status === 'SOON') {
        this.events_soon.push(arr_event[index])
      } else {
        this.events_end.push(arr_event[index])
      }
    }

    this.events_soon.sort((a, b) => a.event_date.localeCompare(b.event_date));
    //console.log("this.loading"+JSON.stringify(this.events))

    this.loading = false;
    //console.log("this.loading"+ this.loading)
  },

  methods: {
    parseRegistrationDate(value) {
      if (!value) {
        return null;
      }

      const parsedDate = new Date(String(value).replace(' ', 'T'));
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    },
    isEventOpen(event) {
      if (!event || event.event_status !== 'OPEN') {
        return false;
      }

      const startDate = this.parseRegistrationDate(event.registration_start_text);
      const endDate = this.parseRegistrationDate(event.registration_end_text);
      const now = new Date();

      return Boolean(startDate && endDate && now >= startDate && now <= endDate);
    },
    async getEvents() {
      const res = await axios.get("/v1/events");
      return res.data;
    },
  },
};
</script>

<style scoped>
.event-cover {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  padding: 0;
  border: 0;
}

.event-card {
  position: relative;
  display: block;
}

.event-status-badge {
  position: absolute;
  top: 0.675rem;
  right: 0.675rem;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 0.315rem;
  padding: 0.27rem 0.54rem;
  border-radius: 999px;
  color: #fff;
  font-size: 0.675rem;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 0.18rem 0.54rem rgb(0 0 0 / 28%);
  white-space: nowrap;
}

.event-status-open {
  background-color: #118cff;
}

.event-status-closed {
  background-color: #4f565b;
}

.event-status-upcoming {
  background-color: #0d6efd;
}

.event-live-dot {
  width: 0.378rem;
  height: 0.378rem;
  border-radius: 50%;
  background-color: #fff;
  animation: event-live-pulse 2.8s ease-in-out infinite;
}

@keyframes event-live-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(0.72);
  }
}

.skeleton-card {
  border-radius: 0.6em;
}

.skeleton-caption {
  box-shadow: 0 0 1em rgb(0 0 0 / 20%);
  border-bottom-left-radius: 0.6em;
  border-bottom-right-radius: 0.6em;
  border: 0;
  background: #fff;
}

.skeleton {
  position: relative;
  overflow: hidden;
  background-color: #e9ecef;
}

.skeleton::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(233, 236, 239, 0) 0%, rgba(255, 255, 255, 0.7) 50%, rgba(233, 236, 239, 0) 100%);
  animation: skeleton-shimmer 1.2s infinite;
}

.skeleton-image {
  width: 100%;
  height: 220px;
  border-top-left-radius: 0.6em;
  border-top-right-radius: 0.6em;
}

.skeleton-title {
  height: 24px;
  width: 75%;
  margin-bottom: 12px;
}

.skeleton-line {
  height: 16px;
  width: 95%;
  margin-bottom: 10px;
}

.skeleton-line-short {
  width: 60%;
  margin-bottom: 0;
}

@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>